var scope_0 = require('/Users/dan/Projects/nus/seaways/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f4e4ab8b94f751b7a58e1abeadb7f60.js').default;
var scope_1 = require('/Users/dan/Projects/nus/seaways/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/40817970d6df0d8ca32c0ba81336f806.js').default;
var scope_2 = require('/Users/dan/Projects/nus/seaways/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9408389f220feca2dfb6f298f64055d0.js').default;
var scope_3 = require('/Users/dan/Projects/nus/seaways/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/Users/dan/Projects/nus/seaways/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec422d07c2f062e0650fcab54e1d6a8a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    